import LogoIcon from "@/nav-localized/assets/logo.svg?react";
import { TitleColor } from "./styles";
import { BUITheme } from "@blofin/blofin-ui";
import { FC } from "react";

const Logo: FC<{ theme: BUITheme }> = ({ theme }) => {
  return (
    <LogoIcon
      className={`w-[107px] h-[28px] ${TitleColor({
        theme: theme
      })}`}
    />
  );
};

export default Logo;
